import router from '@/router';
import axios from 'axios'
import { ElMessage } from "element-plus";

export function fetch(options: any, responseType?: any) {
  return new Promise((resolve, reject) => {
    let access_token = sessionStorage.getItem('access_token')
    if (access_token) {
      access_token = options.no_Bearer ? access_token : `Bearer ${access_token}`
    }

    const headers: any = {
      'Content-Type': 'application/json',
      Authorization: access_token
    }

    const instance = axios.create({
      //instance创建一个axios实例，可以自定义配置，可在 axios文档中查看详情
      //所有的请求都会带上这些配置，比如全局都要用的身份信息等。
      headers,
      responseType: responseType ? responseType : '',
      timeout: 30 * 1000 // 30秒超时
    })
    instance(options)
      .then(response => {
        try {
          response.data.message = response.data.message.replace(/服务调用失败：/g, '')
        } catch (err) {
          console.error(err)
        }
        resolve(response)
      })
      .catch(error => {
        if (error.response.data.code == 'SZ1002') {
          ElMessage({
            message: "登录已失效，请重新登录",
            type: "error",
          });
          router.push({
            path: `/`
          })
        } else if (error.response.data.code) {
          ElMessage({
            message: error.response.data.message,
            type: "error",
          });
        } else if (error.response.data.error_description) {
          ElMessage({
            message: error.response.data.error_description,
            type: "error",
          });
          reject(error)
        } else if (error.response.data.error && error.response.data.error_description == null) {
          ElMessage({
            message: "登录已失效，请重新登录",
            type: "error",
          });
          router.push({
            path: `/`
          })
        } else if (error.response.data.error || error.response.status == 500) {
          ElMessage({
            message: "服务器开小差了，请稍后再试",
            type: "error",
          });
          reject(error)
        } else {
          resolve(error)
        }
      })
  })
}
